import { render, staticRenderFns } from "./InvocationGraph.vue?vue&type=template&id=40bd3592&scoped=true"
import script from "./InvocationGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvocationGraph.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InvocationGraph.vue?vue&type=style&index=0&id=40bd3592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd3592",
  null
  
)

export default component.exports